module.exports = __webpack_public_path__ + "static/media/ZEVEN.32ce60e4.svg";